import React, { useContext, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { ApplicationContext } from "@context/ApplicationContext";
import AboriginalFlag from "@components/Icons/AboriginalFlag";
import TorresStraitFlag from "@components/Icons/TorresStraitFlag";
import "./style.scss";

const AcknowledgementOfCountry = () => {
    const { whiteLabel } = useContext(ApplicationContext);
    const location = useLocation();


    const pageTextColor = useMemo(() => {
        if (location.pathname === "/welcome") {
            return whiteLabel?.subscriber_group?.subscriber_group_welcome_page?.page_text_color;
        } if (location.pathname === "/lets-get-started") {
            return whiteLabel?.subscriber_group?.subscriber_group_get_started?.page_text_color;
        }
        return null;
    }, [location.pathname, whiteLabel]);


    const textStyle = pageTextColor ? { color: pageTextColor } : {};

    return (
        <div className="acknowledgement__wrapper">
            <div className="acknowledgement__text" style={textStyle}>
                Choovie Group acknowledges the Aboriginal and Torres Strait Islander people as the Traditional Owners of Country throughout Australia. We celebrate their stories, culture and tradition and pay our respect to elders past, present and emerging.
            </div>

            <div className="acknowledgement__flag-wrapper">
                <AboriginalFlag className="acknowledgement__flag" />
                <TorresStraitFlag className="acknowledgement__flag" />
            </div>
        </div>
    );
};

export default AcknowledgementOfCountry;
